module.exports = __webpack_public_path__ + "img/partner03.7651e4f1.png";